export const educationData = [
    {
        id: 1,
        institution: 'University of Asia Pacific, Dhaka',
        course: 'B.Sc in Computer Science and Engineering',
        startYear: '2015',
        endYear: '2019'
    },
    {
        id: 2,
        institution: 'Jahangirnagar University, Dhaka',
        course: 'M.Sc in Computer Science',
        startYear: '2021',
        endYear: '2022'
    },
    {
        id: 3,
        institution: 'Programming Hero',
        course: 'Complete Web Development Course',
        startYear: '2022',
        endYear: 'Present'
    },
]